import { defineMessages } from 'react-intl-next';

export const messages: {
    zero_query_collaborator_profile_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_confluence_pages_created_30_days_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_confluence_pages_created_7_days_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_confluence_pages_created_collaborator_7_days_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_confluence_pages_created_collaborator_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_confluence_pages_created_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_my_work_items_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_collaborator_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_issues_assigned_to_me_in_the_past_7_days_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_issues_i_created_in_the_last_month_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_recent_tickets_created_by_me_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_show_all_the_bugs_assigned_to_me_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_show_high_priority_tickets_assigned_to_me_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_show_me_all_of_my_in_progress_work_items_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_show_tickets_due_this_week_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_nlq_what_are_my_open_tickets_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_tickets_assigned_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_tickets_assigned_collaborator_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_tickets_created_collaborator_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_jira_tickets_created_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_third_party_google_collaborator_docs_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_third_party_google_my_docs_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_third_party_sharepoint_collaborator_docs_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_third_party_sharepoint_my_docs_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_third_party_slack_collaborator_messages_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_third_party_slack_my_messages_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    zero_query_who_is_suggestion: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	zero_query_collaborator_profile_suggestion: {
		id: 'search_dialog_zero_query_collaborator_profile_suggestion',
		defaultMessage: "{personAvatar} {name}'s profile",
		description: "Suggestion asking for another user's profile",
	},
	zero_query_confluence_pages_created_30_days_suggestion: {
		id: 'search_dialog_zero_query_confluence_pages_created_30_days_suggestion',
		defaultMessage: '{productIcon} Confluence pages I created in the {dateIcon} last 30 days',
		description: 'Suggestion asking for Confluence pages created by the user in the last 30 days',
	},
	zero_query_confluence_pages_created_7_days_suggestion: {
		id: 'search_dialog_zero_query_confluence_pages_created_7_days_suggestion',
		defaultMessage: '{productIcon} Confluence pages I created in the {dateIcon} last 7 days',
		description: 'Suggestion asking for Confluence pages created by the user in the last 7 days',
	},
	zero_query_confluence_pages_created_collaborator_7_days_suggestion: {
		id: 'search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion',
		defaultMessage:
			'{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days',
		description:
			'Suggestion asking for Confluence pages created by another user in the last 7 days',
	},
	zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: {
		id: 'search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion',
		defaultMessage:
			'{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days',
		description:
			'Suggestion asking for Confluence pages created by another user in the last 30 days',
	},
	zero_query_confluence_pages_created_collaborator_suggestion: {
		id: 'search_dialog_zero_query_confluence_pages_created_collaborator_suggestion',
		defaultMessage: '{productIcon} Confluence pages created by {personAvatar} {name}',
		description: 'Suggestion asking for Confluence pages created by another user',
	},
	zero_query_confluence_pages_created_suggestion: {
		id: 'search_dialog_zero_query_confluence_pages_created_suggestion',
		defaultMessage: '{productIcon} Confluence pages I created',
		description: 'Suggestion asking for Confluence pages created by the user',
	},
	zero_query_jira_my_work_items_suggestion: {
		id: 'search_dialog_zero_query_jira_my_work_items_suggestion',
		defaultMessage: 'Show my {productIcon} work items',
		description: 'Suggestion asking for Jira my work items',
	},
	zero_query_jira_nlq_collaborator_suggestion: {
		id: 'search_dialog_zero_query_jira_nlq_collaborator_suggestion',
		defaultMessage: 'Recent open items assigned to {name}',
		description: 'Suggestion asking for recent open items assigned to another user',
	},
	zero_query_jira_nlq_issues_assigned_to_me_in_the_past_7_days_suggestion: {
		id: 'search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion',
		defaultMessage: 'Issues assigned to me in the past 7 days',
		description: 'Suggestion asking for issues assigned to the user in the past 7 days',
	},
	zero_query_jira_nlq_issues_i_created_in_the_last_month_suggestion: {
		id: 'search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion',
		defaultMessage: 'Issues I created in the last month',
		description: 'Suggestion asking for issues created by the user in the last month',
	},
	zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: {
		id: 'search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion',
		defaultMessage: 'Progress for epics created by me',
		description: 'Suggestion asking for the progress of epics created by the user',
	},
	zero_query_jira_nlq_recent_tickets_created_by_me_suggestion: {
		id: 'search_dialog_zero_query_recent_tickets_created_by_me_suggestion',
		defaultMessage: 'Recent tickets created by me',
		description: 'Suggestion asking for recent tickets created by the user',
	},
	zero_query_jira_nlq_show_all_the_bugs_assigned_to_me_suggestion: {
		id: 'search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion',
		defaultMessage: 'Show all the bugs assigned to me',
		description: 'Suggestion asking for all the bugs assigned to the user',
	},
	zero_query_jira_nlq_show_high_priority_tickets_assigned_to_me_suggestion: {
		id: 'search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion',
		defaultMessage: 'Show high priority tickets assigned to me',
		description: 'Suggestion asking for high priority tickets assigned to the user',
	},
	zero_query_jira_nlq_show_me_all_of_my_in_progress_work_items_suggestion: {
		id: 'search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion',
		defaultMessage: 'Show me all of my in-progress work items',
		description: "Suggestion asking for all of the user's in-progress work items",
	},
	zero_query_jira_nlq_show_tickets_due_this_week_suggestion: {
		id: 'search_dialog_zero_query_show_tickets_due_this_week_suggestion',
		defaultMessage: 'Show tickets due this week',
		description: 'Suggestion asking for tickets due this week',
	},
	zero_query_jira_nlq_what_are_my_open_tickets_suggestion: {
		id: 'search_dialog_zero_query_what_are_my_open_tickets_suggestion',
		defaultMessage: 'What are my open tickets?',
		description: "Suggestion asking what are the user's open tickets?",
	},
	zero_query_jira_tickets_assigned_suggestion: {
		id: 'search_dialog_zero_query_jira_tickets_assigned_suggestion',
		defaultMessage: '{productIcon} Jira tickets assigned to me',
		description: 'Suggestion asking for recent tickets assigned to another user',
	},
	zero_query_jira_tickets_assigned_collaborator_suggestion: {
		id: 'search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion',
		defaultMessage: '{productIcon} tickets assigned to {personAvatar} {name}',
		description: 'Suggestion asking for Jira tickets assigned to another user',
	},
	zero_query_jira_tickets_created_collaborator_suggestion: {
		id: 'search_dialog_zero_query_jira_tickets_created_collaborator_suggestion',
		defaultMessage: '{productIcon} Jira tickets created by {personAvatar} {name}',
		description: 'Suggestion asking for recent tickets created by another user',
	},
	zero_query_jira_tickets_created_suggestion: {
		id: 'search_dialog_zero_query_jira_tickets_created_suggestion',
		defaultMessage: '{productIcon} Jira tickets I created',
		description: 'Suggestion asking for recent tickets created by another user',
	},
	zero_query_third_party_google_collaborator_docs_suggestion: {
		id: 'search_dialog_zero_query_third_party_google_collaborator_docs_suggestion',
		defaultMessage: '{productIcon} Google docs from {personAvatar} {name}',
		description: 'Suggestion asking for Google docs from another user',
	},
	zero_query_third_party_google_my_docs_suggestion: {
		id: 'search_dialog_zero_query_third_party_google_my_docs_suggestion',
		defaultMessage: 'My {productIcon} Google Drive docs',
		description: "Suggestion asking for the user's Google Drive docs",
	},
	zero_query_third_party_sharepoint_collaborator_docs_suggestion: {
		id: 'search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion',
		defaultMessage: '{productIcon} SharePoint docs from {personAvatar} {name}',
		description: 'Suggestion asking for SharePoint docs from another user',
	},
	zero_query_third_party_sharepoint_my_docs_suggestion: {
		id: 'search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion',
		defaultMessage: 'My {productIcon} SharePoint documents',
		description: "Suggestion asking for the user's SharePoint documents",
	},
	zero_query_third_party_slack_collaborator_messages_suggestion: {
		id: 'search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion',
		defaultMessage: '{productIcon} Slack messages from {personAvatar} {name}',
		description: 'Suggestion asking for Slack messages from another user',
	},
	zero_query_third_party_slack_my_messages_suggestion: {
		id: 'search_dialog_zero_query_third_party_slack_my_messages_suggestion',
		defaultMessage: 'My {productIcon} Slack messages',
		description: "Suggestion asking for the user's Slack messages",
	},
	zero_query_who_is_suggestion: {
		id: 'search_dialog_zero_query_who_is_suggestion',
		defaultMessage: 'Who is {name}?',
		description: 'Suggestion asking who another user is',
	},
});
